interface SpeedInsightsEvent {
  url?: string | URL;
}

const UUID_SEGMENT =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

const ROUTE_PATTERNS: Array<[RegExp, string | null]> = [
  [/^\/join\/[^/]+\/[^/]+$/, null],
  [/^\/auth\/invitation\/[^/]+$/, null],
  [/^\/chat\/[^/]+$/, '/chat/[id]'],
  [new RegExp(`^/project/${UUID_SEGMENT}$`), '/project/[id]'],
  [
    new RegExp(`^/project/${UUID_SEGMENT}/checklists/${UUID_SEGMENT}$`),
    '/project/[id]/checklists/[checklistId]',
  ],
  [
    new RegExp(`^/project/${UUID_SEGMENT}/edit-regulatory-documents$`),
    '/project/[id]/edit-regulatory-documents',
  ],
  [
    new RegExp(`^/project/${UUID_SEGMENT}/manage-members$`),
    '/project/[id]/manage-members',
  ],
  [
    new RegExp(`^/project/${UUID_SEGMENT}/edit-description$`),
    '/project/[id]/edit-description',
  ],
  [new RegExp(`^/tools/${UUID_SEGMENT}$`), '/tools/[id]'],
  [/^\/rendering\/share\/[^/]+$/, '/rendering/share/[id]'],
  [/^\/canvas\/share\/[^/]+$/, '/canvas/share/[token]'],
];

function getPathname(input: string | URL): string | null {
  if (input instanceof URL) {
    return input.pathname;
  }

  try {
    if (input.startsWith('/')) {
      return new URL(input, 'https://app.arkyv.ai').pathname;
    }

    return new URL(input).pathname;
  } catch {
    return null;
  }
}

export function normalizeSpeedInsightsPath(
  input: string | URL | undefined,
): string | null {
  if (!input) return null;

  const pathname = getPathname(input);
  if (!pathname) return null;

  for (const [pattern, replacement] of ROUTE_PATTERNS) {
    if (pattern.test(pathname)) {
      return replacement;
    }
  }

  return pathname;
}

export function filterSpeedInsightsEvent<T extends SpeedInsightsEvent>(
  event: T,
): T | null {
  const normalizedPath = normalizeSpeedInsightsPath(event.url);
  if (!normalizedPath) {
    return null;
  }

  return {
    ...event,
    url: normalizedPath,
  };
}
